import { HStack, StackDivider, Text, VStack } from '@chakra-ui/react'

const ProductDelivery = () => {
  return (
    <VStack>
      <HStack divider={<StackDivider />} justify="center" spacing={4} w="100%">
        <Text align="center" fontSize="sm">
          40 års erfarenhet
        </Text>

        <Text align="center" fontSize="sm">
          Egna tekniker och montörer
        </Text>

        <Text align="center" bg="#dff7df" borderRadius="sm" fontSize="sm" p={1}>
          Lagerfört sortiment
        </Text>
      </HStack>
    </VStack>
  )
}

export default ProductDelivery
